<div class="col-md-4 col-sm-12 text-center">
  <ng-container i18n>實裝日</ng-container>:
  {{ this.releaseDate }}
</div>
<div class="col-md-4 col-sm-12 text-center">
  <ng-container i18n>取得</ng-container>:
  {{ this.getMethod }}
</div>
<div class="col-md-4 col-sm-12 text-center">
  <ng-container i18n>稀有度</ng-container>:
  {{ this.rarity }}
</div>
